export const kppValidator = (val): boolean | string => {
  const reg = /\d+/i
  return (!val || (reg.test(val) && val.length === 9) || 'Неверно введен КПП')
}
